// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 989 ? "component---src-core-pages-page-template-tsx" : chunkId) + "-" + {"530":"c514905238fc91b2b83f","989":"14f7344b61ba8cb1b8d1"}[chunkId] + ".js";
};